import {Routes} from "@angular/router";
import {WorkflowCspOneDowngradeCuComponent} from "./workflow-csp-one-downgrade-cu.component";

export const workflowCspOneDowngradeCuRouting: Routes = [
    { path: 'csp/downgrade-cu/:aid', component: WorkflowCspOneDowngradeCuComponent, children: [
            { path: 'info', component: WorkflowCspOneDowngradeCuComponent },
            { path: 'address', component: WorkflowCspOneDowngradeCuComponent },
            { path: 'payment', component: WorkflowCspOneDowngradeCuComponent },
            { path: 'checkout', component: WorkflowCspOneDowngradeCuComponent },
            { path: 'complete', component: WorkflowCspOneDowngradeCuComponent },
            { path: '', redirectTo: 'info', pathMatch: 'full' },
    ]},
]
